






























































import { Button } from 'element-ui'
import { Vue, Component, Prop } from 'vue-property-decorator'

import Currency from '@/models/currency'
import Passenger, { PassengerStatuses } from '@/models/passenger'
import PassengerExtra, {
  PassengerExtraTypes,
  PassengerExtraValueTypes,
} from '@/models/passenger-extra'

@Component({
  components: {
    [Button.name]: Button,
  },
})
export default class PassengerPriceBreakdown extends Vue {
  @Prop() passenger!: Passenger
  @Prop() isFolded!: boolean
  @Prop() currentCustomerIsLead!: boolean
  @Prop() isDefaultDeck!: boolean
  @Prop() passengerDisplayedTotal!: string
  @Prop(String) currencyCode!: Currency

  passengerExtraValueTypes = PassengerExtraValueTypes

  get passengerCancelled(): boolean {
    return this.passenger.passengerStatus === PassengerStatuses.Cancelled
  }

  get passengerExtrasOrdered(): PassengerExtra[] {
    if (this.passengerCancelled) {
      return []
    }

    const extras = this.$store.getters.getPassengerExtrasByPassengerId(
      this.passenger.id,
    )

    return this.$_.orderBy(extras, [
      (e) => e.extraType === PassengerExtraTypes.Extra,
      (e) => e.valueType === PassengerExtraValueTypes.Fixed,
      (e) => e.amountCents,
    ])
  }
}
